import { StatusProduto } from '@/types/produto'

/**
 * Códigos estáveis do catálogo canônico (Políticas Vigentes por Produto 25/10/2026 §1 e §10;
 * AN-PP1 §1.1). Espelha `br.com.originei.common.produto.CodigosProduto`. Decisões da tela
 * (Outra necessidade, Campanha) usam o código — nunca o nome exibido.
 */
export const CODIGOS_PRODUTO = {
  RISK_SACADO: 'RISK_SACADO',
  VENDOR_FINANCE: 'VENDOR_FINANCE',
  RECEIVABLES_ADVANCE: 'RECEIVABLES_ADVANCE',
  PRIVATE_PAYROLL_LOAN: 'PRIVATE_PAYROLL_LOAN',
  HOME_EQUITY: 'HOME_EQUITY',
  WORKING_CAPITAL_CORPORATE: 'WORKING_CAPITAL_CORPORATE',
  WORKING_CAPITAL_CAPEX: 'WORKING_CAPITAL_CAPEX',
  INCENTIVE_CAMPAIGN: 'INCENTIVE_CAMPAIGN',
  SACADO360: 'SACADO360',
  SACADOR360: 'SACADOR360',
  OTHER_NEED: 'OTHER_NEED',
  BOOK_ENTRY_DUPLICATE: 'BOOK_ENTRY_DUPLICATE',
} as const

export type CodigoProdutoCanonico = (typeof CODIGOS_PRODUTO)[keyof typeof CODIGOS_PRODUTO]

/** "Outra necessidade" (PDF §8): sem elegibilidade, checklist nem simulação. */
export const CODIGO_OUTRA_NECESSIDADE = CODIGOS_PRODUTO.OTHER_NEED
/** Campanha de Incentivo (PDF §6): simulação pelo modelo CAMPANHA. */
export const CODIGO_CAMPANHA_INCENTIVO = CODIGOS_PRODUTO.INCENTIVE_CAMPAIGN

export const CODIGOS_CANONICOS: ReadonlySet<string> = new Set<string>(Object.values(CODIGOS_PRODUTO))

export const codigoCanonico = (codigo: string | null | undefined): boolean =>
  !!codigo && CODIGOS_CANONICOS.has(codigo)

/** Mesmo padrão do CHECK da V13 de produtos. */
export const PADRAO_CODIGO_PRODUTO = /^[A-Z][A-Z0-9_]{2,63}$/

/** Rótulos dos status (AN-PP1 §2.1). Exaustivo: falta um status e o `tsc` acusa. */
export const ROTULOS_STATUS_PRODUTO: Record<StatusProduto, string> = {
  ATIVA: 'Ativa',
  ATIVA_COM_ANALISE: 'Avaliação Originei',
  SEM_POLITICA_SIMULACAO: 'Simulação indisponível',
  RETIRADA: 'Retirada',
}

export const rotuloStatusProduto = (status: string | null | undefined): string =>
  status ? ROTULOS_STATUS_PRODUTO[status as StatusProduto] ?? status : '—'
